
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/proptrading/ranking",
      function () {
        return require("private-next-pages/proptrading/ranking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/proptrading/ranking"])
      });
    }
  